import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { GRADING_MODAL } = ANALYTICS_CATEGORIES;

export const triggerGradingModalSubmitFeedbackButtonClickedEvent = (label: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: GRADING_MODAL,
		customData: { label },
		name: 'dlr_grading_modal_submit_feedback_button_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
